import { render, staticRenderFns } from "./ReportTypeGroups.vue?vue&type=template&id=fbc5b38a"
import script from "./ReportTypeGroups.vue?vue&type=script&lang=js"
export * from "./ReportTypeGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports